module.exports = __webpack_public_path__ + "static/img/shanchu.f4da344.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/shanchu.png
// module id = sZqG
// module chunks = 24